<template>
    <div>
        <b-card v-if="asCard">
            <b-row v-for="col in tableColumns" v-bind:key="col.key">
                <b-col md="3" class="my-1">
                    <strong>{{ $t(col.label) }} :</strong>
                </b-col>
                <b-col md="8" class="my-1">
                    <em-form-helper :name="col.key" :metadata="col" :value="getKeyValue(col)" :entity="entity"/>
                </b-col>
            </b-row>
        </b-card>

        <div class="content" v-if="!asCard">
            <div class="card my-1">
                <div
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                >
                </div>
                <div class="row">
                    <div class="form-group col-md-2" v-for="col in tableColumns" v-bind:key="col.key">
                        <label class="control-label">{{$t(col.label) }}:</label>
                        <b-alert show variant="secondary">
                            <em-form-helper :name="col.key" :metadata="col" :value="getKeyValue(col)" :entity="entity"/>
                        </b-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import model from '@/model/index'
    import EmFormHelper from "@/components/em/EmFormHelper";

    export default {
        name: "EmEntityViewer",
        components: {EmFormHelper},
        props: {
            'entity': String,
            'object': Object,
            title: String,
            asCard: {
                type: Boolean,
                default: false
            },
            $_emCustomVuexMixin_configs: String
        },
        computed: {
            tableColumns() {
                if (this.$_emCustomVuexMixin_configs !== undefined && this.$_emCustomVuexMixin_configs != null) {
                    return model[this.entity][this.$_emCustomVuexMixin_configs];
                } else {
                    return model[this.entity].gridFields();
                }
            }
        },
        methods: {
            getKeyValue(field) {
                let fieldValue = this.object[field.key]
                // switch (field.form.type) {
                //     case 'boolean':
                //         return fieldValue ? 'Yes' : 'No'
                //     case 'select': {
                //         let selectedOption = field.form.options.filter(x => x.value === fieldValue)
                //         if (selectedOption.length > 0) {
                //             return selectedOption[0].text;
                //         }
                //         return null
                //     }
                //     default:
                //         return fieldValue
                // }
                //boolean、select特殊类型Form会在EmFormHelper中转换
                return fieldValue
            }
        }
    }
</script>

<style scoped>

</style>